import { SuggestedProduct, VirtualAssistantRepository } from '@/components/virtual-assistant/virtual-assistant.repository';
import { ProductModel } from '@/models';

const stubSuggestedProduct: SuggestedProduct = {
	productName: 'Egon Muller : Riesling Scharzhofberger Auslese 2019',
	url: 'https://www.millesima.fr/egon-muller-riesling-scharzhofberger-auslese-2019.html',
	image: 'J2261_2009NM_c.png',
	shortdesc: '1 Bouteille (75cl) en coffret',
	listPrice: '890.00',
	unitPrice: '890.00',
	offerPrice: null,
	hasPromotion: false,
	promotionLabel: '',
	disponibilite: 'L',
	cepages: 'riesling',
	appellation: 'Wiltingen',
	couleur: 'Blanc',
	notes: '99/100 Parker',
	justification:
		"Un Riesling d'exception allemand, noté 99/100 par Robert Parker. Fruité intense et aromatique, " +
		'avec une minéralité remarquable.',
	partnumber: 'J2261/09/CC/C/6',
};

const stubItem = {
	_id: 'stub-item-1',
	partnumber: 'J2261/09/CC/C/6',
	taxRate: '20',
	listPrice: 890,
	offerPrice: 890,
	htPrice: 741.67,
	unitPrice: 890,
	seoKeyword: '/egon-muller-riesling-scharzhofberger-auslese-2019.html',
	img360: '',
	shortdesc: '1 Bouteille (75cl) en coffret',
	attributes: {},
	availabilityMessage: 'Livrable',
	stock: 10,
	availability: new Date(),
	isCustomizable: false,
	marge: '',
	gtin_cond: '',
	gtin_unit: '',
	hrefLang: [],
	isPrevSale: false,
};

const stubBaseProduct: ProductModel = {
	_id: 'stub-product-1',
	nbItems: 1,
	partnumber: 'J2261/09/CC/C/6',
	productName: 'Egon Muller : Riesling Scharzhofberger Auslese 2019',
	storeId: '',
	hrefLang: [],
	image: 'J2261_2009NM_c.png',
	catchPhrase:
		"Un Riesling d'exception allemand, noté 99/100 par Robert Parker. Fruité intense et aromatique, " +
		"avec une minéralité remarquable. Un cadeau d'exception pour les amateurs de grands vins. Présenté en coffret.",
	imageSize: {
		_id: '',
		fileName: 'J2261_2009NM_c.png',
		sizeByFolder: {
			'150px': { width: 150, height: 150 },
			'280px': { width: 280, height: 280 },
			'531px': { width: 531, height: 531 },
			'1000px': { width: 1000, height: 1000 },
		},
	},
	categories: [],
	listPrice: 890,
	offerPrice: 890,
	seoKeyword: '/egon-muller-riesling-scharzhofberger-auslese-2019.html',
	title: 'Egon Muller : Riesling Scharzhofberger Auslese 2019',
	metaDesc: '',
	item: stubItem,
	items: [stubItem],
	itemsCP: [],
	exclusive_cellar: false,
	attributes: {
		appellation: { valueId: '', name: 'appellation', value: 'Wiltingen', sequence: '', displayable: true },
		couleur: { valueId: '', name: 'couleur', value: 'Blanc', sequence: '', displayable: true },
		cepage_detail: { valueId: '', name: 'cepage_detail', value: 'Riesling', sequence: '', displayable: true },
	},
	display: true,
	primeur: false,
	topRating: { valueId: '', name: '', value: '99/100 Parker', sequence: '', displayable: true },
	isSpirit: false,
};

export class StubVirtualAssistantRepository implements VirtualAssistantRepository {
	timeout = 3000;

	async submit(request: string): ReturnType<VirtualAssistantRepository['submit']> {
		if (request === '__INIT__') {
			return new Promise((resolve) => {
				setTimeout(() => {
					resolve({
						sessionId: '123',
						message: "Quel vin découvrons nous aujourd'hui ? ",
						suggestions: ['Vins rouges', 'Vins blancs du médoc', 'Vins étrangers'],
						products: [stubSuggestedProduct, stubSuggestedProduct, stubSuggestedProduct],
						baseProducts: [stubBaseProduct, stubBaseProduct, stubBaseProduct],
					});
				}, this.timeout);
			});
		}
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve({
					sessionId: '123',
					message: request,
					suggestions: ['Vins rouges', 'Vins blancs du médoc', 'Vins étrangers'],
					products: [stubSuggestedProduct, stubSuggestedProduct],
					baseProducts: [stubBaseProduct, stubBaseProduct],
				});
			}, this.timeout);
		});
	}
}
